import { configureStore } from '@reduxjs/toolkit'
import { reducer as userInfoReducer } from './user-info'

export const store = configureStore({
  reducer: {
    userInfo: userInfoReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch